import { render, staticRenderFns } from "./SearchSortTag.vue?vue&type=template&id=0934815e&scoped=true&"
import script from "./SearchSortTag.vue?vue&type=script&lang=js&"
export * from "./SearchSortTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0934815e",
  null
  
)

export default component.exports